export enum ButtonDirection {
  UP,
  DOWN,
  LEFT,
  RIGHT,
}

type ButtonArrowProps = {
  direction?: ButtonDirection;
  fill?: string;
  className?: string;
};

const DIRECTION = {
  [ButtonDirection.UP]: { transform: 'rotate(-90deg)' },
  [ButtonDirection.DOWN]: { transform: 'rotate(90deg)' },
  [ButtonDirection.LEFT]: { transform: 'scaleX(-1)' },
  [ButtonDirection.RIGHT]: { transform: 'scaleX(1)' }, // in case you want to transition
};

export default function ButtonArrow({
  direction = ButtonDirection.RIGHT,
  className = '',
}: ButtonArrowProps) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 24 24`}
        style={DIRECTION[direction]}
        className={`${className}`}
      >
        <path
          fillRule="evenodd"
          d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
          clipRule="evenodd"
        />
      </svg>
    </>
  );
}
